module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/live-white-b0bafacaa4825626d3d8cfc95dbb7fce.gif";